import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import firebaseConfig from "../Config/allwell-4g-watch-db.json"

//firebase config
const firebaseConfigFor4GWatchDB = {
    apiKey: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_4G_WATCH_DB_APP_ID 
  }

const app = initializeApp(firebaseConfigFor4GWatchDB);

const db = getFirestore(app);

export default db;